import enLang from './entries/en-US';
import viLang from './entries/vi-VN';
import zhLang from './entries/zh-Hans-CN';
import arLang from './entries/ar_SA';
import itLang from './entries/it_IT';
import esLang from './entries/es_ES';
import frLang from './entries/fr_FR';

const AppLocale = {
  en: enLang,
  vi: viLang,
};

export default AppLocale;
